<div class="questionnaire-field-spacer d-flex flex-column">
    <input type="text" pInputText [formControl]="formControl" />
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
